<template>
    <div class="coin-icon">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 72.59 79.45" style="enable-background:new 0 0 72.59 79.45;" xml:space="preserve">
        <circle :fill="colors.theme == 'dark' ? '#000' : '#ccd5d3'" class="st0" cx="36" cy="43" r="35"/>
        <circle class="st1" cx="36" cy="36" r="35"/>
        <g>
            <polygon class="st2" points="55.09,49.09 55.09,44.6 55.09,38.24 48.72,38.24 42.36,38.24 36,38.24 29.64,38.24 23.28,38.24 
                16.91,38.24 16.91,44.6 16.91,49.09 23.28,49.09 23.28,44.6 29.64,44.6 36,44.6 42.36,44.6 48.72,44.6 48.72,49.09 	"/>
            <rect x="23.67" y="22.91" class="st2" width="7.83" height="7.83"/>
            <rect x="40.88" y="22.91" class="st2" width="7.83" height="7.83"/>
        </g>
        </svg>
    </div>
</template>

<script>

export default {
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
        // console.log('Colors: ', this.colors)
    }
}
</script>

<style lang="scss" scoped>
            // .st0{fill:#ccd5d3;}
            .st1{fill:#EE1E4C;}
            .st2{fill:#FFFFFF;}
</style>
